import React, { useState, useContext } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import { toast } from 'react-toastify';

interface InternalNotesSectionProps {
    rechnungId: number;
    initialNote: string;
    onNoteSaved: (note: string) => void;
}

const InternalNotesSection: React.FC<InternalNotesSectionProps> = ({ rechnungId, initialNote, onNoteSaved }) => {
    const authContext = useContext(AuthContext);
    const [internalNote, setInternalNote] = useState<string>(initialNote);
    const [isSaving, setIsSaving] = useState(false);

    if (!authContext) {
        throw new Error('InternalNotesSection must be used within an AuthProvider');
    }

    const { token } = authContext;

    const handleSaveInternalNote = async () => {
        setIsSaving(true);
        try {
            const response = await fetch(`/api/rechnungen/${rechnungId}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    internalNote,
                }),
            });

            if (!response.ok) {
                throw new Error('Fehler beim Speichern der internen Notiz');
            }

            const data = await response.json();
            setInternalNote(data.internalNote || '');
            onNoteSaved(data.internalNote || '');
            toast.success('Interne Notiz erfolgreich gespeichert');
        } catch (error) {
            console.error('Error saving internal note:', error);
            toast.error(error instanceof Error ? error.message : 'Fehler beim Speichern der internen Notiz');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="internal-notes-section">
            <h2>Interne Notizen</h2>
            <div className="internal-notes-content">
                <textarea
                    className="internal-notes-textarea"
                    value={internalNote}
                    onChange={(e) => setInternalNote(e.target.value)}
                    placeholder="Interne Notizen zur Rechnung hier eingeben..."
                    rows={6}
                />
                <div className="internal-notes-actions">
                    <button
                        className="save-notes-btn"
                        onClick={handleSaveInternalNote}
                        disabled={isSaving}
                    >
                        {isSaving ? '💾 Speichert...' : '💾 Speichern'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InternalNotesSection;
